import { CustomSerializer } from './custom-serializer';

/**
 * A custom serializer for handling potentially null date strings.
 *
 * @class
 * @name NullableDateSerializer
 */
export class NullableDateSerializer extends CustomSerializer {
	deserialize(data: string) {
		return data ? new Date(data) : null;
	}

	serialize(data: Date) {
		return data ? new Date(data) : null;
	}
}

export type NullableDateSerializerClass = new () => NullableDateSerializer;
